import axios from 'axios';
import { Toast } from 'vant';
import store from '@/store';
import { getLoginKey, removeLoginKey } from './auth';
var ua = navigator.userAgent;
var ISwxwork = ua.match(/wxwork/i) == 'wxwork'
/**
 * http://www.docway.net/dashboard?personal 接口文档地址
 * pc 测试环境 http://admintest.zhiwuhui.net/
 */

const service = axios.create({
  baseURL: `${process.env.VUE_APP_BASE_URL}/admin`,
  timeout: 50000,
  responseType: 'json'
});

service.interceptors.request.use(
  config => {
    if (store.getters.loginKey) {
      // 每个请求添加登录凭证
      config.headers['login-key'] = getLoginKey();
      Toast.loading({ message: '查询中', forbidClick: true, duration: 0 })
    }
    config.headers['client-type'] = ISwxwork ? 2 : 1
    return config;
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
);

service.interceptors.response.use(response => {
  const res = response.data;
  Toast.clear();
  if (res.errcode !== 0) {
    Toast.fail(res.errmsg);
    if (res.errcode === 403) {
      // 登录过期
      removeLoginKey();
      localStorage.removeItem('useInfo');
      location.reload()
    }
  } else {
    return res;
  }
  return res;
},
  error => {
    console.log('err' + error) // for debug
    Toast.clear();
    return Promise.reject(error)
  });

export default service;